import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const createPushNotification = "/marcom/pushNotification/create";
const getAllRegisteredUser = "/marcom/pushNotification/getAllRegisteredUsers";
const campaignReports = "/marcom/pushNotification/getAllCampaignReport";
const apiReports = "/marcom/pushNotification/getAllApiReport";
const getAllNotificationTemplate =
  "/marcom/pushNotification/getAllPushNotificationTemplate";

const createTemplate = "/marcom/pushNotification/pushNotificationTemplates";
export default {
  createPushNotification(payload) {
    return Repository.post(`${createPushNotification}`, payload);
  },

  createTemplate(payload) {
    return Repository.post(`${createTemplate}`, payload);
  },

  getAllRegisteredUsers(payload) {
    return Repository.post(`${getAllRegisteredUser}`, payload);
  },

  getAllCampaignReports(payload) {
    return Repository.post(`${campaignReports}`, payload);
  },

  getAllApiReports(payload) {
    return Repository.post(`${apiReports}`, payload);
  },

  getAllNotificationTemplate(payload) {
    return Repository.post(`${getAllNotificationTemplate}`, payload);
  },
};
